import React from 'react';

const SearchTable = ({searchTerm,handleSearchChange}) => {
  return (
    <div id="examplemgm_filter" className="dataTables_filter"><label><input type="search" className placeholder="Search..."  value={searchTerm}
    onChange={handleSearchChange} aria-controls="examplemgm" /></label></div>
  );
};

export default SearchTable;
